import PillCTA from './PillCTA';

export { type PillCTAProps } from './PillCTA';
export default PillCTA;
